import api from "./api";

class OdvManager {

    dettaglioOdvGamma(ditta: number | string, n_reg: number | string) {
        return api.get(`odv/${ditta}/${n_reg}/`)
    }

    righeOdvGamma(ditta: number | string,n_reg: number | string, config?: any) {
        return api.get(`odv/${ditta}/${n_reg}/righe`, config)
    }
}

const odvManager = new OdvManager()

export default odvManager
